<template>
    <div class="LocationBar">
        <div class="inner">
            <ul class="Location">
                <li class="Location__item home">
                    <a href="/" class="Location__item--btn">
                        <img src="@/assets/resource/icon/loctiom_home.svg" alt="">
                    </a>
                </li>
                <li class="Location__item" v-for="(item, index) in menuItems">
                    <a href="javascript:;" class="Location__item--btn" :class="{ active: getLocationOption(index + 1) }" @click.prevent="Location_select(index + 1)">
                        <p>{{item.label}}</p>
                    </a>
                    <slide-up-down class="Location__item--select" :active="getLocationOption(index + 1)">
                        <ul>
                            <li v-for="(subItem, subIndex) in item.subItems">
                                <component class="Location__item--option" :is="subItem.menuUrl.startsWith('http') ? 'a' : 'router-link'" :href="subItem.menuUrl" :to="subItem.menuUrl" @click="Location_select(index + 1)" :target="subItem.linkMethod">{{ subItem.menuName }}</component>
                            </li>
                        </ul>
                    </slide-up-down>
                </li>
            </ul>
            <div class="Location-sharing">
                <a href="javascript:;" @click.prevent="Location_sharing_active" class="Location-sharing--btn" :class="{ active: Location_sharing }"></a>
                <slide-up-down class="Location-sharing__list" :active="Location_sharing">
                    <a href="javascript:;" class="blog" @click="[$commonUtils.fn_sendFB('blog'), Location_sharing_active()]"></a>
                    <a href="javascript:;" class="x" @click="[$commonUtils.fn_sendFB('x'), Location_sharing_active()]"></a>
                    <a href="javascript:;" class="talk" @click="[$commonUtils.fn_sendFB('talk'), Location_sharing_active()]"></a>
                    <a href="javascript:;" class="link" @click="[$commonUtils.fn_sendFB('link'), Location_sharing_active()]"></a>
                </slide-up-down>
            </div>
        </div>
    </div>
</template>



<script>

import SlideUpDown from 'vue-slide-up-down';

export default {
    components: {
        SlideUpDown,
    },
    data() {
        return {
            Location_option1: false,
            Location_option2: false,
            Location_option3: false,
            Location_sharing: false,
            menuItems: [],
            activeIndex: -1,
            activeMenu: {},
        };
    },
    methods: {
        Location_sharing_active() {
            this.Location_sharing = !this.Location_sharing;
        },
        handleClickOutside(event) {
            const locationBar = this.$el; // LocationBar 컴포넌트의 루트 요소
            if (!locationBar.contains(event.target)) {
                this.closeAllMenus(); // 외부 클릭 시 모든 메뉴 닫기
            }
        },
        Location_select(num) {
            this['Location_option' + num] = !this['Location_option' + num];
        },
        getLocationOption(num) {
            return this['Location_option' + num];
        },
        setLocationMenu(){
            this.menuItems = []
            let path = this.$commonUtils.getMenuPath()

            const list = this.menuList.sort((a, b) => {
                return b.depth - a.depth
            })

            // menuList의 url과 현재 url이 같으면 activeMenu에 저장, menuType이 B,C인 메뉴만 적용
            let menuNo = ''
            for(let i = 0; i < list.length; i++){
                if(list[i].menuUrl == path && list[i].useYn == 'Y'){
                    this.activeMenu = list[i]
                    if(this.activeMenu.depth == 4){
                        menuNo = this.activeMenu.parentMenuNo
                        this.activeMenu = {}
                    }
                    if(this.activeMenu.menuType){
                        break
                    }
                }
                if(menuNo != '' && list[i].menuNo == menuNo) this.activeMenu = list[i]
            }

            // activeMenu의 depth를 구하고, 상위 메뉴들도 설정해준다.
            let depth = this.activeMenu.depth

            for(let i = depth - 1; i >= 0; i--){
                let menuItem = {subItems: []}

                menuItem.label = this.activeMenu.menuName

                for(let j = 0; j < this.menuList.length; j++){
                    if(this.menuList[j].parentMenuNo == this.activeMenu.parentMenuNo && this.menuList[j].gnbYn == 'Y'){
                        menuItem.subItems.push(this.menuList[j])
                    }
                }

                this.menuItems[i] = menuItem

                for(let j = 0; j < this.menuList.length; j++){
                    if(this.menuList[j].menuNo == this.activeMenu.parentMenuNo){
                        this.activeMenu = this.menuList[j]
                        break
                    }
                }

            }
        },
        closeAllMenus() {
            this.Location_option1 = false;
            this.Location_option2 = false;
            this.Location_option3 = false;
            this.Location_sharing = false;
        },
    },
    mounted() {
        this.setLocationMenu()
        document.addEventListener('click', this.handleClickOutside);
    },
    watch: {
        $route(to, from){
            if(to.path != from.path){
                this.setLocationMenu()
            }else{
                if((to.path.indexOf('/center') > -1 || to.path.indexOf('/clinic') > -1) && Object.keys(this.$route.query).includes('deptCd')){
                    this.setLocationMenu()
                }
            }
        }
    },
    beforeUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }
};
</script>